import { DISTRIBUTION_COMPARISON_REPORT, DEDUCTION_COMPARISON_REPORT, REPORT_401K } from "../../types";

const PayrollComparisonsReducer = (state = {}, action) => {
    if ([DISTRIBUTION_COMPARISON_REPORT, DEDUCTION_COMPARISON_REPORT, REPORT_401K].includes(action.type)) {
        return { ...state, [action.type]: action.payload }
    }
    return state;
};

export default PayrollComparisonsReducer;
